export default function useActiveAsPath(href) {
  const { location } = window;
  const asPath = `${location.pathname}${location.search}`;
  return asPath === href;
}
